const education = [
  {
    date: "2016 - 2018",
    image: "/images/about/education/ku.jpeg",
    department: "Bilgisayar Programcılığı",
    school: "Kastamonu Üniversitesi",
  } 
];

export default education;